import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { GROWTH_CATALOGS } from "./model/growth-copy.ts";
import { GROWTH_ERROR_COPY } from "./model/growth-error-copy.ts";

// Settings → Rewards ("Earn free credits", "Refer & earn") hides behind `rewards` (S43.09, D1369).
export const growthBrowserModule: BrowserModule = defineBrowserModule("growth")
  .withErrorCopy(GROWTH_ERROR_COPY)
  .withScreens({
    milestones: {
      path: "/milestones",
      title: phrase(GROWTH_CATALOGS, "titleMilestones"),
      layout: "app",
      flag: "rewards",
      load: () => import("./ui/sections/milestones-screen.tsx"),
    },
    invitations: {
      path: "/invitations",
      title: phrase(GROWTH_CATALOGS, "titleInvitations"),
      layout: "app",
      flag: "rewards",
      load: () => import("./ui/sections/invitations-screen.tsx"),
    },
    liveEvents: {
      path: "/live-events",
      title: phrase(GROWTH_CATALOGS, "titleLiveEvents"),
      layout: "app",
      flag: "live-events",
      load: () => import("./ui/sections/live-events-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "live-events",
      group: "support",
      label: phrase(GROWTH_CATALOGS, "navLiveEvents"),
      href: "/live-events",
      icon: "video",
      order: 300,
      flag: "live-events",
    },
    {
      id: "milestones",
      group: "settings-rewards",
      label: phrase(GROWTH_CATALOGS, "navMilestones"),
      href: "/milestones",
      icon: "gift",
      order: 310,
      flag: "rewards",
    },
    {
      id: "refer",
      group: "settings-rewards",
      label: phrase(GROWTH_CATALOGS, "navRefer"),
      href: "/invitations",
      icon: "users",
      order: 920,
      flag: "rewards",
    },
  ]);
